import { render, staticRenderFns } from "./IngressoBancali.vue?vue&type=template&id=886b6e2a&scoped=true"
import script from "./IngressoBancali.vue?vue&type=script&lang=js"
export * from "./IngressoBancali.vue?vue&type=script&lang=js"
import style0 from "./IngressoBancali.vue?vue&type=style&index=0&id=886b6e2a&prod&scoped=true&lang=css"
import style1 from "./IngressoBancali.vue?vue&type=style&index=1&id=886b6e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886b6e2a",
  null
  
)

export default component.exports